import React from "react";
import {
  FaCloud,
  FaCode,
  FaTools,
  FaMicrosoft,
  FaNetworkWired,
  FaUserCog,
  FaLock,
  FaTicketAlt,
  FaTerminal,
  FaSmile,
} from "react-icons/fa";

const Skills = () => {
  const skillCategories = [
    {
      category: "Cloud Platforms",
      icon: <FaCloud />,
      skills: ["Intro to AWS", "Actively learning Azure"],
    },
    {
      category: "Frontend",
      icon: <FaCode />,
      skills: ["ReactJS", "HTML", "CSS", "Bootstrap", "Figma"],
    },
    {
      category: "Dev Tools",
      icon: <FaTools />,
      skills: ["GitHub", "Visual Studio Code", "GitLab"],
    },
    {
      category: "Microsoft Tools",
      icon: <FaMicrosoft />,
      skills: ["Microsoft 365", "Excel (Basic)"],
    },
    {
      category: "Networking",
      icon: <FaNetworkWired />,
      skills: [
        "Basic understanding",
        "Troubleshooting",
        "Twisted-pair cables fixtures",
      ],
    },
    {
      category: "IT Support & Troubleshooting",
      icon: <FaUserCog />,
      skills: [
        "Windows 10/11",
        "VPN & VM setup",
        "Password resets",
        "Account lockouts",
        "Printer/Hardware troubleshooting",
      ],
    },
    {
      category: "Identity & Access Management",
      icon: <FaLock />,
      skills: ["Azure Active Directory", "Entra ID", "SSO", "RBAC"],
    },
    {
      category: "Ticketing & Collaboration Tools",
      icon: <FaTicketAlt />,
      skills: ["Zendesk", "Jira"],
    },
    {
      category: "Scripting & Automation",
      icon: <FaTerminal />,
      skills: ["PowerShell", "SQL (Intermediate)", "Python (Basic)"],
    },
    {
      category: "Soft Skills",
      icon: <FaSmile />,
      skills: [
        "Communication",
        "Teamwork",
        "Customer Service",
        "Documentation",
        "Requirement Gathering",
      ],
    },
  ];

  return (
    <section
      id="skills"
      style={{
        padding: "50px",
        backgroundColor: "#000", // black background
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#fff",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "50px",
          fontSize: "2.8rem",
          fontWeight: "700",
          color: "#fcfdfdff",
          letterSpacing: "1px",
        }}
      >
        Skills
      </h2>

      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        {skillCategories.map((cat, index) => (
          <div key={index} style={{ marginBottom: "35px" }}>
            <h3
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: "#00b894",
                fontSize: "1.6rem",
                marginBottom: "15px",
              }}
            >
              {cat.icon} {cat.category}
            </h3>
            <ul
              style={{
                listStyle: "none",
                paddingLeft: "0",
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
              }}
            >
              {cat.skills.map((skill, idx) => (
                <li
                  key={idx}
                  style={{
                    backgroundColor: "#111",
                    color: "#fff",
                    padding: "10px 18px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                    transition: "transform 0.3s, background 0.3s",
                    cursor: "default",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.backgroundColor = "#00b894";
                    e.currentTarget.style.color = "#000";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.backgroundColor = "#111";
                    e.currentTarget.style.color = "#fff";
                  }}
                >
                  <span style={{ color: "#00b894" }}>•</span> {skill}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
